import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import { getUserData } from 'utils/graphQLFunctions';
import fragments from 'utils/graphql/fragments';

const withGameLeaderboardData = BaseComponent => {
  const GAME_LEADERBOARD_QUERY = gql`
    query MyGetGameRankings(
      $dailyInput: GetGameRankings!
      $weeklyInput: GetGameRankings!
      $lifetimeInput: GetGameRankings!
    ) {
      daily: gameRankings(input: $dailyInput) {
        ...GameRankingsFields
      }
      weekly: gameRankings(input: $weeklyInput) {
        ...GameRankingsFields
      }
      lifetime: gameRankings(input: $lifetimeInput) {
        ...GameRankingsFields
      }
    }
    ${fragments.gameRankings}
  `;

  const withData = compose(
    graphql(GAME_LEADERBOARD_QUERY, {
      name: 'gameRankingsData',
      options: props => ({
        variables: {
          dailyInput: {
            gameId: parseInt(props.gameData.id, 10),
            leaderboardType: 'daily',
            leaderboardCount: 50
          },
          weeklyInput: {
            gameId: parseInt(props.gameData.id, 10),
            leaderboardType: 'weekly',
            leaderboardCount: 50
          },
          lifetimeInput: {
            gameId: parseInt(props.gameData.id, 10),
            leaderboardType: 'lifetime',
            leaderboardCount: 50
          }
        },
        fetchPolicy: 'network-only'
      }),
      props: ({ ownProps, gameRankingsData }) => ({
        gameRankingsData,
        handleRefresh: () => gameRankingsData.refetch()
      })
    }),
    getUserData({
      name: 'userData'
    })
  );

  return withData(BaseComponent);
};

export default withGameLeaderboardData;
